// @flow
import { httpRequest, httpRequestWithToken, getScribeBackendEndpoint } from '../../utils/http';

const updateTrainingConversations = async ({ title }: { title: string }) =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/training-conversations`,
    method: 'POST',
    payload: { title },
  });

const getTrainingConversations = async () =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/training-conversations`,
    method: 'GET',
  });

const tagConversation = async ({ id, tags }: { id: string, tags: Object }) =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/conversations/${id}`,
    method: 'PATCH',
    payload: { tags },
  });

const getProfile = async ({ user }: { user?: Object }) => {
  let url = `${getScribeBackendEndpoint()}/api/v1/users/me`;
  const firebaseAuthUID = user ? user.firebaseAuthUID || user.id : null;
  if (firebaseAuthUID) {
    url = `${url}?firebaseAuthUID=${firebaseAuthUID}`;
  }

  return httpRequestWithToken({
    url,
    method: 'GET',
  });
};

const getCaptionerProfile = async () =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/captioners/me`,
    method: 'GET',
  });

const saveReport = async ({ report, firebaseAuthUID }: { report: Object, firebaseAuthUID: string }) =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/reports?firebaseAuthUID=${firebaseAuthUID}`,
    method: 'POST',
    payload: report,
  });

const getReportTags = async () =>
  httpRequestWithToken({
    url: `${getScribeBackendEndpoint()}/api/v1/reports`,
    method: 'GET',
  });

export const conversations = {
  getTrainingConversations,
  tagConversation,
  updateTrainingConversations,
};

export const users = {
  getCaptionerProfile,
  getProfile,
};

export const reports = {
  getReportTags,
  saveReport,
};
